// eslint-disable-next-line @typescript-eslint/no-explicit-any
function hasContent(node: any): boolean {
  if (!node) return false;
  if (typeof node.text === 'string' && node.text.trim().length > 0) return true;
  if (node.type === 'comment-image') return true;
  if (Array.isArray(node.children)) {
    return node.children.some(hasContent);
  }
  return false;
}

export function isLexicalStateNotEmpty(state: string): boolean {
  if (typeof state !== 'string' || state.length === 0) return false;
  try {
    const parsed = JSON.parse(state);
    const root = parsed?.root;
    if (!root || !Array.isArray(root.children)) return false;
    return hasContent(root);
  } catch {
    return false;
  }
}
